const truncateRecommendations = (isListTruncated, recommendations, truncatedCount) => {
  return isListTruncated ? [...recommendations].slice(0, truncatedCount) : recommendations;
};

export default truncateRecommendations;
